export default __webpack_public_path__ + "static/media/my_menu_active.d0aa2ebd.png";